var _module_exports = "<div ng-if=\"$ctrl.showDateSeparator()\" class=\"date-wrapper\">\n  {{ $ctrl.dateSeparator }}\n</div>";;
var path = '/workspace/src/app/components/notifications/notification-date-separator/notification-date-separator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;